import { render, staticRenderFns } from "./revenueSegmentation.vue?vue&type=template&id=7a3955c8&scoped=true&"
import script from "./revenueSegmentation.vue?vue&type=script&lang=js&"
export * from "./revenueSegmentation.vue?vue&type=script&lang=js&"
import style0 from "./revenueSegmentation.vue?vue&type=style&index=0&id=7a3955c8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3955c8",
  null
  
)

export default component.exports